//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.19.0.0 (NJsonSchema v10.9.0.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming



export

class CategoryConfigVm {
    
  imageUrl :
      string;
    
  name :
      string;

constructor() 
{
      this.imageUrl = "" ;
        this.name = "" ;
  }
}

export

class SimpleEntity {
    
  identifier :
      string;

constructor() 
{
      this.identifier = "" ;
  }
}

export

class BaseEntity extends SimpleEntity {
    
  createdOn :
      string;
    
  modifiedOn :
      string;

constructor() 
{
  super();
      this.createdOn = "" ;
        this.modifiedOn = "" ;
  }
}

export

class AppConfig extends BaseEntity {
    
  disabledOn :
      string;
    
  categories :
      CategoryConfig[];

constructor() 
{
  super();
      this.disabledOn = "" ;
        this.categories = [];
  }
}

export

class CategoryConfig {
    
  name :
      string;
    
  attachment :
      Attachment;

constructor() 
{
      this.name = "" ;
        this.attachment = new Attachment();
  }
}

export

class BaseAttachment {
    
  fileIdentifier :
      string;
    
  fileName :
      string;
    
  mimeType :
      string;
    
  lastModifiedOn :
      string;
    
  subDir :
      string;

constructor() 
{
      this.fileIdentifier = "" ;
        this.fileName = "" ;
        this.mimeType = "" ;
        this.lastModifiedOn = "" ;
        this.subDir = "" ;
  }
}

export

class FileSystemAttachment extends BaseAttachment {
    
  storagePath :
      string;

constructor() 
{
  super();
      this.storagePath = "" ;
  }
}

export

class Attachment extends FileSystemAttachment {

constructor() 
{
  super();
}
}

export

class RequestVM {
    
  identifier :
      string;
    
  from :
      NameIdentifier;
    
  to :
      NameIdentifier;

constructor() 
{
      this.identifier = "" ;
        this.from = new NameIdentifier();
        this.to = new NameIdentifier();
  }
}

export

class NameIdentifier {
    
  name :
      string;
    
  identifier :
      string;

constructor() 
{
      this.name = "" ;
        this.identifier = "" ;
  }
}

export

class BaseApiLoginResponse {
    
  identifier :
      string;
    
  username :
      string;
    
  role :
      string;
    
  token :
      string;

constructor() 
{
      this.identifier = "" ;
        this.username = "" ;
        this.role = "" ;
        this.token = "" ;
  }
}

export

class BaseCredential {
    
  username :
      string;
    
  password :
      string;

constructor() 
{
      this.username = "" ;
        this.password = "" ;
  }
}

export

class LanguageCredential extends BaseCredential {
    
  preferredCulture :
      string;

constructor() 
{
  super();
      this.preferredCulture = "" ;
  }
}

export

class LanguageCredentialWithBirthDate extends LanguageCredential {
    
  birthDate :
      string;
    
  name :
      string;
    
  surname :
      string;
    
  telephone :
      string;

constructor() 
{
  super();
      this.birthDate = "" ;
        this.name = "" ;
        this.surname = "" ;
        this.telephone = "" ;
  }
}

export

class ChangeCustomPasswordVM {
    
  oldPassword :
      string;
    
  newPassword :
      string;

constructor() 
{
      this.oldPassword = "" ;
        this.newPassword = "" ;
  }
}

export

class LoginResponse {
    
  token :
      string;
    
  userIdentifier :
      string;

constructor() 
{
      this.token = "" ;
        this.userIdentifier = "" ;
  }
}

export

class RegisterVm {
    
  identifier :
      string;
    
  name :
      string;
    
  surname :
      string;
    
  telephone :
      string;
    
  birthDate :
      string;

constructor() 
{
      this.identifier = "" ;
        this.name = "" ;
        this.surname = "" ;
        this.telephone = "" ;
        this.birthDate = "" ;
  }
}

export

class BaseChatRoomVm {
    
  identifier :
      string;
    
  type :
      string;

constructor() 
{
      this.identifier = "" ;
        this.type = "" ;
  }
}

export

class ChatListVm extends BaseChatRoomVm {
    
  name :
      string;
    
  image :
      string;
    
  lastMessage :
      ChatRoomMessageVM;
    
  hasNewMessages :
      boolean;
    
  userIdentifier :
      string;
    
  participants :
      string[];

constructor() 
{
  super();
      this.name = "" ;
        this.image = "" ;
        this.lastMessage = new ChatRoomMessageVM();
        this.hasNewMessages = false ;
        this.userIdentifier = "" ;
        this.participants = [];
  }
}

export

class ChatRoomMessageVM {
    
  identifier :
      string;
    
  date :
      string;
    
  senderIdentifier :
      string;
    
  text :
      string;
    
  quotedMessage :
      ChatRoomMessageVM;
    
  metaData :
      string;
    
  lastReadDates :
      AutoDictionaryOfStringAndNullableDateTime;

constructor() 
{
      this.identifier = "" ;
        this.date = "" ;
        this.senderIdentifier = "" ;
        this.text = "" ;
        this.quotedMessage = new ChatRoomMessageVM();
        this.metaData = "" ;
        this.lastReadDates = new AutoDictionaryOfStringAndNullableDateTime();
  }
}

export

class AutoDictionaryOfStringAndNullableDateTime {
    
  item :
      string;

  [key: string]: string | any;

constructor() 
{
      this.item = "" ;
  }
}

export

class CommunityDetailVm {
    
  identifier :
      string;
    
  type :
      string;
    
  category :
      string;
    
  title :
      string;
    
  iban :
      string;
    
  xPayApiKey :
      string;
    
  xPaySecret :
      string;
    
  sellingConditionsName :
      string;
    
  shipmentDescription :
      string;
    
  shipmentAmount :
      number;
    
  description :
      string;
    
  likes :
      NameIdentifier[];
    
  admins :
      NameIdentifier[];
    
  moderators :
      NameIdentifier[];
    
  allegati :
      string[];
    
  gallery :
      string[];
    
  backgroundImage :
      string;
    
  logo :
      string;
    
  tags :
      string[];
    
  isCertified :
      boolean;
    
  owner :
      NameIdentifier;
    
  isLiked :
      boolean;
    
  isLikeRequestSent :
      boolean;
    
  isSubscribed :
      boolean;
    
  canInfo :
      boolean;
    
  canInvite :
      boolean;
    
  canContent :
      boolean;
    
  canSettings :
      boolean;
    
  communityType :
      CommunityType;
    
  dateFrom :
      string;
    
  dateTo :
      string;
    
  openFrom :
      string;
    
  openTo :
      string;
    
  address :
      string;
    
  transferRecipient :
      string;
    
  communities :
      CategoryItemsOfNameIdentifier[];
    
  slug :
      string;
    
  contatti :
      string;
    
  isOnlineEvent :
      boolean;

constructor() 
{
      this.identifier = "" ;
        this.type = "" ;
        this.category = "" ;
        this.title = "" ;
        this.iban = "" ;
        this.xPayApiKey = "" ;
        this.xPaySecret = "" ;
        this.sellingConditionsName = "" ;
        this.shipmentDescription = "" ;
        this.shipmentAmount = null ;
        this.description = "" ;
        this.likes = [];
        this.admins = [];
        this.moderators = [];
        this.allegati = [];
        this.gallery = [];
        this.backgroundImage = "" ;
        this.logo = "" ;
        this.tags = [];
        this.isCertified = false ;
        this.owner = new NameIdentifier();
        this.isLiked = false ;
        this.isLikeRequestSent = false ;
        this.isSubscribed = false ;
        this.canInfo = false ;
        this.canInvite = false ;
        this.canContent = false ;
        this.canSettings = false ;
        this.communityType = null;
        this.dateFrom = "" ;
        this.dateTo = "" ;
        this.openFrom = "" ;
        this.openTo = "" ;
        this.address = "" ;
        this.transferRecipient = "" ;
        this.communities = [];
        this.slug = "" ;
        this.contatti = "" ;
        this.isOnlineEvent = false ;
  }
}

export enum CommunityType {
    Public = 0,
    OnRequest = 1,
    Close = 2,
}

export

class CategoryItemsOfNameIdentifier {
    
  category :
      string;
    
  items :
      NameIdentifier[];

constructor() 
{
      this.category = "" ;
        this.items = [];
  }
}

export

class SaveForumTagVM {
    
  communityIdentifier :
      string;
    
  tag :
      ForumTag;
    
  published :
      boolean;

constructor() 
{
      this.communityIdentifier = "" ;
        this.tag = new ForumTag();
        this.published = false ;
  }
}

export

class ForumTag {
    
  identifier :
      string;
    
  tag :
      string;
    
  description :
      string;

constructor() 
{
      this.identifier = "" ;
        this.tag = "" ;
        this.description = "" ;
  }
}

export

class DiscoverCardVM {
    
  identifier :
      string;
    
  title :
      string;
    
  category :
      string;
    
  type :
      string;
    
  subscribers :
      number;
    
  dateRangeInfo :
      string;
    
  backgoundImageUrl :
      string;
    
  profileImageUrl :
      string;
    
  slug :
      string;

constructor() 
{
      this.identifier = "" ;
        this.title = "" ;
        this.category = "" ;
        this.type = "" ;
        this.subscribers = null ;
        this.dateRangeInfo = "" ;
        this.backgoundImageUrl = "" ;
        this.profileImageUrl = "" ;
        this.slug = "" ;
  }
}

export

class DiscoverFilterVM {
    
  skip :
      number;
    
  take :
      number;
    
  interestedCommunity :
      boolean;
    
  categoryList :
      string[];
    
  typeList :
      string[];

constructor() 
{
      this.skip = null ;
        this.take = null ;
        this.interestedCommunity = false ;
        this.categoryList = [];
        this.typeList = [];
  }
}

export

class AddToCartVm {
    
  communityIdentifier :
      string;
    
  itemIdentifier :
      string;
    
  variationItemIdentifier :
      string;
    
  amount :
      number;
    
  note :
      string;
    
  date :
      string;
    
  period :
      DatePeriod;

constructor() 
{
      this.communityIdentifier = "" ;
        this.itemIdentifier = "" ;
        this.variationItemIdentifier = "" ;
        this.amount = null ;
        this.note = "" ;
        this.date = "" ;
        this.period = new DatePeriod();
  }
}

export

class DatePeriod {
    
  start :
      string;
    
  end :
      string;

constructor() 
{
      this.start = "" ;
        this.end = "" ;
  }
}

export

class CartVM {
    
  cartIdentifier :
      string;
    
  userIdentifier :
      string;
    
  communityIdentifier :
      string;
    
  totalPrice :
      number;
    
  shipmentDescription :
      string;
    
  shipmentAmount :
      number;
    
  notes :
      string;
    
  xPayApiKey :
      string;
    
  shippingAddress :
      Address;
    
  cartItems :
      CartItemVM[];

constructor() 
{
      this.cartIdentifier = "" ;
        this.userIdentifier = "" ;
        this.communityIdentifier = "" ;
        this.totalPrice = null ;
        this.shipmentDescription = "" ;
        this.shipmentAmount = null ;
        this.notes = "" ;
        this.xPayApiKey = "" ;
        this.shippingAddress = new Address();
        this.cartItems = [];
  }
}

export

class Address {
    
  name :
      string;
    
  typedAddress :
      string;
    
  streetNumber :
      string;
    
  route :
      string;
    
  locality :
      string;
    
  province :
      string;
    
  region :
      string;
    
  country :
      string;
    
  countryCode :
      string;
    
  postalCode :
      string;
    
  latitude :
      number;
    
  longitude :
      number;
    
  completeAddress :
      string;

constructor() 
{
      this.name = "" ;
        this.typedAddress = "" ;
        this.streetNumber = "" ;
        this.route = "" ;
        this.locality = "" ;
        this.province = "" ;
        this.region = "" ;
        this.country = "" ;
        this.countryCode = "" ;
        this.postalCode = "" ;
        this.latitude = null ;
        this.longitude = null ;
        this.completeAddress = "" ;
  }
}

export

class CartItemVM {
    
  thumbnailUrl :
      string;
    
  title :
      string;
    
  variation :
      ShopItemVariation;
    
  amount :
      number;
    
  totalPrice :
      number;
    
  isShippable :
      boolean;

constructor() 
{
      this.thumbnailUrl = "" ;
        this.title = "" ;
        this.variation = new ShopItemVariation();
        this.amount = null ;
        this.totalPrice = null ;
        this.isShippable = false ;
  }
}

export

class ShopItemVariation {
    
  identifier :
      string;
    
  price :
      number;
    
  variations :
      { [key: string]: string; };

constructor() 
{
      this.identifier = "" ;
        this.price = null ;
        this.variations = {};
  }
}

export

class ChangeCartAmountVm {
    
  communityIdentifier :
      string;
    
  cartItems :
      ItemAmountVM[];

constructor() 
{
      this.communityIdentifier = "" ;
        this.cartItems = [];
  }
}

export

class ItemAmountVM {
    
  cartItemIdentifier :
      string;
    
  amount :
      number;

constructor() 
{
      this.cartItemIdentifier = "" ;
        this.amount = null ;
  }
}

export

class SetAddressVM {
    
  identifier :
      string;
    
  shippingAddress :
      Address;

constructor() 
{
      this.identifier = "" ;
        this.shippingAddress = new Address();
  }
}

export

class CategoryAttachmentVM {
    
  id :
      string;
    
  communityIdentifier :
      string;
    
  name :
      string;

constructor() 
{
      this.id = "" ;
        this.communityIdentifier = "" ;
        this.name = "" ;
  }
}

export

class ChatRoomVm extends BaseChatRoomVm {
    
  createdOn :
      string;
    
  name :
      string;
    
  description :
      string;
    
  image :
      string;
    
  lastMessage :
      ChatRoomMessageVM;
    
  participants :
      NameIdentifier[];
    
  isSubscribed :
      boolean;

constructor() 
{
  super();
      this.createdOn = "" ;
        this.name = "" ;
        this.description = "" ;
        this.image = "" ;
        this.lastMessage = new ChatRoomMessageVM();
        this.participants = [];
        this.isSubscribed = false ;
  }
}

export

class CreateChatRoomVm {
    
  name :
      string;
    
  description :
      string;
    
  participants :
      NameIdentifier[];

constructor() 
{
      this.name = "" ;
        this.description = "" ;
        this.participants = [];
  }
}

export

class UpdateChatRoomVm extends CreateChatRoomVm {
    
  identifier :
      string;

constructor() 
{
  super();
      this.identifier = "" ;
  }
}

export

class SetListVmOfGuid {
    
  identifier :
      string;
    
  values :
      string[];

constructor() 
{
      this.identifier = "" ;
        this.values = [];
  }
}

export

class PermissionSettings {
    
  info :
      string;
    
  invitation :
      string;
    
  content :
      string;

constructor() 
{
      this.info = "" ;
        this.invitation = "" ;
        this.content = "" ;
  }
}

export

class SetValueVmOfPermissionSettings {
    
  identifier :
      string;
    
  value :
      PermissionSettings;

constructor() 
{
      this.identifier = "" ;
        this.value = new PermissionSettings();
  }
}

export

class ChatRoomAllowanceVm {
    
  identifier :
      string;
    
  canInfo :
      boolean;
    
  canInvite :
      boolean;
    
  canContent :
      boolean;
    
  canSettings :
      boolean;

constructor() 
{
      this.identifier = "" ;
        this.canInfo = false ;
        this.canInvite = false ;
        this.canContent = false ;
        this.canSettings = false ;
  }
}

export

class CommentVm {
    
  identifier :
      string;
    
  createdOn :
      string;
    
  text :
      string;
    
  replyCount :
      number;
    
  createdBy :
      NameIdentifier;
    
  liked :
      boolean;

constructor() 
{
      this.identifier = "" ;
        this.createdOn = "" ;
        this.text = "" ;
        this.replyCount = null ;
        this.createdBy = new NameIdentifier();
        this.liked = false ;
  }
}

export

class AddCommentVm {
    
  containerIdentifier :
      string;
    
  grandParentIdentifier :
      string;
    
  parentIdentifier :
      string;
    
  text :
      string;
    
  commentType :
      string;

constructor() 
{
      this.containerIdentifier = "" ;
        this.grandParentIdentifier = "" ;
        this.parentIdentifier = "" ;
        this.text = "" ;
        this.commentType = "" ;
  }
}

export

class CommentListVM {
    
  identifier :
      string;
    
  parentIdentifier :
      string;
    
  commentType :
      string;
    
  text :
      string;

constructor() 
{
      this.identifier = "" ;
        this.parentIdentifier = "" ;
        this.commentType = "" ;
        this.text = "" ;
  }
}

export

class CommunityListVm {
    
  identifier :
      string;
    
  title :
      string;
    
  likes :
      number;
    
  backgroundImage :
      string;
    
  logo :
      string;
    
  isCertified :
      boolean;
    
  isFiera :
      boolean;
    
  slug :
      string;

constructor() 
{
      this.identifier = "" ;
        this.title = "" ;
        this.likes = null ;
        this.backgroundImage = "" ;
        this.logo = "" ;
        this.isCertified = false ;
        this.isFiera = false ;
        this.slug = "" ;
  }
}

export

class SearchResultVm {
    
  createdOn :
      string;
    
  type :
      string;
    
  identifier :
      string;
    
  parentIdentifier :
      string;
    
  parentSlug :
      string;
    
  name :
      string;
    
  image :
      string;
    
  isTopic :
      boolean;
    
  isProduct :
      boolean;
    
  isPost :
      boolean;
    
  isForumPost :
      boolean;
    
  tag :
      ForumTag;
    
  slug :
      string;

constructor() 
{
      this.createdOn = "" ;
        this.type = "" ;
        this.identifier = "" ;
        this.parentIdentifier = "" ;
        this.parentSlug = "" ;
        this.name = "" ;
        this.image = "" ;
        this.isTopic = false ;
        this.isProduct = false ;
        this.isPost = false ;
        this.isForumPost = false ;
        this.tag = new ForumTag();
        this.slug = "" ;
  }
}

export

class CommunityByCategoryVm {
    
  category :
      string;
    
  communities :
      CommunityListVm[];

constructor() 
{
      this.category = "" ;
        this.communities = [];
  }
}

export

class CommunityTypeVM {
    
  type :
      CommunityType;
    
  identifier :
      string;

constructor() 
{
      this.type = null;
        this.identifier = "" ;
  }
}

export

class CreateCommunityResponseVM {
    
  identifier :
      string;
    
  slug :
      string;

constructor() 
{
      this.identifier = "" ;
        this.slug = "" ;
  }
}

export

class CreateCommunityVm {
    
  identifier :
      string;
    
  ownerIdentifier :
      string;
    
  isCertified :
      boolean;
    
  xPayApiKey :
      string;
    
  xPaySecret :
      string;
    
  iban :
      string;
    
  transferRecipient :
      string;
    
  shipmentDescription :
      string;
    
  shipmentAmount :
      number;
    
  title :
      string;
    
  description :
      string;
    
  permissionSettings :
      PermissionSettings;
    
  admins :
      string[];
    
  moderators :
      string[];
    
  tags :
      string[];
    
  category :
      string;
    
  communityType :
      CommunityType;

constructor() 
{
      this.identifier = "" ;
        this.ownerIdentifier = "" ;
        this.isCertified = false ;
        this.xPayApiKey = "" ;
        this.xPaySecret = "" ;
        this.iban = "" ;
        this.transferRecipient = "" ;
        this.shipmentDescription = "" ;
        this.shipmentAmount = null ;
        this.title = "" ;
        this.description = "" ;
        this.permissionSettings = new PermissionSettings();
        this.admins = [];
        this.moderators = [];
        this.tags = [];
        this.category = "" ;
        this.communityType = null;
  }
}

export

class CommunityAccessesVM {
    
  communityName :
      string;
    
  accesses :
      AccessVM[];

constructor() 
{
      this.communityName = "" ;
        this.accesses = [];
  }
}

export

class AccessVM {
    
  createdOn :
      string;
    
  userCompletename :
      string;
    
  userEmail :
      string;

constructor() 
{
      this.createdOn = "" ;
        this.userCompletename = "" ;
        this.userEmail = "" ;
  }
}

export

class PostVm {
    
  identifier :
      string;
    
  parentIdentifier :
      string;
    
  publishedDate :
      string;
    
  communityTitle :
      string;
    
  communitySlug :
      string;
    
  title :
      string;
    
  text :
      string;
    
  creator :
      NameIdentifier;
    
  preview :
      string;
    
  attachmentUrl :
      string;
    
  mimeType :
      string;
    
  likes :
      string[];
    
  commentNumber :
      number;
    
  liked :
      boolean;
    
  isAllegato :
      boolean;
    
  tag :
      ForumTag;
    
  category :
      string;
    
  slug :
      string;

constructor() 
{
      this.identifier = "" ;
        this.parentIdentifier = "" ;
        this.publishedDate = "" ;
        this.communityTitle = "" ;
        this.communitySlug = "" ;
        this.title = "" ;
        this.text = "" ;
        this.creator = new NameIdentifier();
        this.preview = "" ;
        this.attachmentUrl = "" ;
        this.mimeType = "" ;
        this.likes = [];
        this.commentNumber = null ;
        this.liked = false ;
        this.isAllegato = false ;
        this.tag = new ForumTag();
        this.category = "" ;
        this.slug = "" ;
  }
}

export

class CommunityListBackendVm extends CommunityListVm {
    
  createdOn :
      string;
    
  owner :
      string;
    
  isOwner :
      boolean;
    
  isAdmin :
      boolean;
    
  isModerator :
      boolean;

constructor() 
{
  super();
      this.createdOn = "" ;
        this.owner = "" ;
        this.isOwner = false ;
        this.isAdmin = false ;
        this.isModerator = false ;
  }
}

export

class DeleteUserVM {
    
  userIdentifier :
      string;
    
  itemIdentifier :
      string;

constructor() 
{
      this.userIdentifier = "" ;
        this.itemIdentifier = "" ;
  }
}

export

class ConversationRoomVm extends BaseChatRoomVm {
    
  userIdentifier :
      string;
    
  name :
      string;
    
  lastMessage :
      ChatRoomMessageVM;
    
  hasNewMessages :
      boolean;

constructor() 
{
  super();
      this.userIdentifier = "" ;
        this.name = "" ;
        this.lastMessage = new ChatRoomMessageVM();
        this.hasNewMessages = false ;
  }
}

export

class DashboardVm {
    
  totalCommunities :
      number;
    
  totalEvents :
      number;
    
  categories :
      KeyValuePairOfStringAndInteger[];

constructor() 
{
      this.totalCommunities = null ;
        this.totalEvents = null ;
        this.categories = [];
  }
}

export

class KeyValuePairOfStringAndInteger {
    
  key :
      string;
    
  value :
      number;

constructor() 
{
      this.key = "" ;
        this.value = null ;
  }
}

export

class EventByCategoryVm {
    
  category :
      string;
    
  events :
      EventVm[];

constructor() 
{
      this.category = "" ;
        this.events = [];
  }
}

export

class EventVm {
    
  identifier :
      string;
    
  dateFrom :
      string;
    
  dateTo :
      string;
    
  name :
      string;
    
  address :
      string;
    
  participants :
      string[];
    
  category :
      string;
    
  coverImage :
      string;
    
  gallery :
      string[];
    
  communityIdentifier :
      string;
    
  isCertified :
      boolean;
    
  slug :
      string;

constructor() 
{
      this.identifier = "" ;
        this.dateFrom = "" ;
        this.dateTo = "" ;
        this.name = "" ;
        this.address = "" ;
        this.participants = [];
        this.category = "" ;
        this.coverImage = "" ;
        this.gallery = [];
        this.communityIdentifier = "" ;
        this.isCertified = false ;
        this.slug = "" ;
  }
}

export

class EventDetailVm {
    
  identifier :
      string;
    
  category :
      string;
    
  title :
      string;
    
  iban :
      string;
    
  xPayApiKey :
      string;
    
  xPaySecret :
      string;
    
  sellingConditionsName :
      string;
    
  shipmentDescription :
      string;
    
  shipmentAmount :
      number;
    
  description :
      string;
    
  likes :
      NameIdentifier[];
    
  admins :
      NameIdentifier[];
    
  moderators :
      NameIdentifier[];
    
  allegati :
      string[];
    
  gallery :
      string[];
    
  backgroundImage :
      string;
    
  logo :
      string;
    
  tags :
      string[];
    
  isCertified :
      boolean;
    
  owner :
      NameIdentifier;
    
  isLiked :
      boolean;
    
  isSubscribed :
      boolean;
    
  canInfo :
      boolean;
    
  canInvite :
      boolean;
    
  canContent :
      boolean;
    
  canSettings :
      boolean;
    
  communityType :
      CommunityType;
    
  dateFrom :
      string;
    
  dateTo :
      string;
    
  address :
      Address;
    
  openFrom :
      string;
    
  openTo :
      string;
    
  isParticipating :
      boolean;
    
  communityIdentifier :
      string;
    
  communityImage :
      string;
    
  transferRecipient :
      string;
    
  isOnlineEvent :
      boolean;

constructor() 
{
      this.identifier = "" ;
        this.category = "" ;
        this.title = "" ;
        this.iban = "" ;
        this.xPayApiKey = "" ;
        this.xPaySecret = "" ;
        this.sellingConditionsName = "" ;
        this.shipmentDescription = "" ;
        this.shipmentAmount = null ;
        this.description = "" ;
        this.likes = [];
        this.admins = [];
        this.moderators = [];
        this.allegati = [];
        this.gallery = [];
        this.backgroundImage = "" ;
        this.logo = "" ;
        this.tags = [];
        this.isCertified = false ;
        this.owner = new NameIdentifier();
        this.isLiked = false ;
        this.isSubscribed = false ;
        this.canInfo = false ;
        this.canInvite = false ;
        this.canContent = false ;
        this.canSettings = false ;
        this.communityType = null;
        this.dateFrom = "" ;
        this.dateTo = "" ;
        this.address = new Address();
        this.openFrom = "" ;
        this.openTo = "" ;
        this.isParticipating = false ;
        this.communityIdentifier = "" ;
        this.communityImage = "" ;
        this.transferRecipient = "" ;
        this.isOnlineEvent = false ;
  }
}

export

class EditEventInfo {
    
  communityIdentifier :
      string;
    
  dateFrom :
      string;
    
  dateTo :
      string;
    
  address :
      Address;
    
  openFrom :
      string;
    
  openTo :
      string;
    
  isOnlineEvent :
      boolean;

constructor() 
{
      this.communityIdentifier = "" ;
        this.dateFrom = "" ;
        this.dateTo = "" ;
        this.address = new Address();
        this.openFrom = "" ;
        this.openTo = "" ;
        this.isOnlineEvent = false ;
  }
}

export

class CreateEventResponseVM {
    
  identifier :
      string;
    
  slug :
      string;

constructor() 
{
      this.identifier = "" ;
        this.slug = "" ;
  }
}

export

class CreateEventVm extends CreateCommunityVm {
    
  communityIdentifier :
      string;
    
  dateFrom :
      string;
    
  dateTo :
      string;
    
  address :
      Address;
    
  openFrom :
      string;
    
  openTo :
      string;
    
  isOnlineEvent :
      boolean;

constructor() 
{
  super();
      this.communityIdentifier = "" ;
        this.dateFrom = "" ;
        this.dateTo = "" ;
        this.address = new Address();
        this.openFrom = "" ;
        this.openTo = "" ;
        this.isOnlineEvent = false ;
  }
}

export

class EventCalendarVM {
    
  date :
      string;
    
  count :
      number;

constructor() 
{
      this.date = "" ;
        this.count = null ;
  }
}

export

class CalendarFIlterVM {
    
  communityIdentifier :
      string;
    
  date :
      string;

constructor() 
{
      this.communityIdentifier = "" ;
        this.date = "" ;
  }
}

export

class FieraListVm {
    
  identifier :
      string;
    
  createdOn :
      string;
    
  dateFrom :
      string;
    
  dateTo :
      string;
    
  name :
      string;
    
  communitiesCount :
      number;
    
  backgroundImage :
      string;
    
  logo :
      string;

constructor() 
{
      this.identifier = "" ;
        this.createdOn = "" ;
        this.dateFrom = "" ;
        this.dateTo = "" ;
        this.name = "" ;
        this.communitiesCount = null ;
        this.backgroundImage = "" ;
        this.logo = "" ;
  }
}

export

class CategoryItemsOfNameSlugIdentifier {
    
  category :
      string;
    
  items :
      NameSlugIdentifier[];

constructor() 
{
      this.category = "" ;
        this.items = [];
  }
}

export

class NameSlugIdentifier extends NameIdentifier {
    
  slug :
      string;

constructor() 
{
  super();
      this.slug = "" ;
  }
}

export

class FieraDetailVm {
    
  identifier :
      string;
    
  dateFrom :
      string;
    
  dateTo :
      string;
    
  title :
      string;
    
  openFrom :
      string;
    
  openTo :
      string;
    
  description :
      string;
    
  contatti :
      string;
    
  likes :
      NameIdentifier[];
    
  communities :
      CategoryItemsOfNameSlugIdentifier[];
    
  backgroundImage :
      string;
    
  logo :
      string;
    
  communityType :
      CommunityType;
    
  canSettings :
      boolean;
    
  canInvite :
      boolean;
    
  canInfo :
      boolean;
    
  canContent :
      boolean;
    
  isLiked :
      boolean;
    
  admins :
      string[];
    
  moderators :
      string[];

constructor() 
{
      this.identifier = "" ;
        this.dateFrom = "" ;
        this.dateTo = "" ;
        this.title = "" ;
        this.openFrom = "" ;
        this.openTo = "" ;
        this.description = "" ;
        this.contatti = "" ;
        this.likes = [];
        this.communities = [];
        this.backgroundImage = "" ;
        this.logo = "" ;
        this.communityType = null;
        this.canSettings = false ;
        this.canInvite = false ;
        this.canInfo = false ;
        this.canContent = false ;
        this.isLiked = false ;
        this.admins = [];
        this.moderators = [];
  }
}

export

class SaveFieraVm {
    
  identifier :
      string;
    
  dateFrom :
      string;
    
  dateTo :
      string;
    
  title :
      string;
    
  openFrom :
      string;
    
  openTo :
      string;
    
  description :
      string;
    
  contatti :
      string;
    
  communities :
      CategoryItemsOfGuid[];
    
  admins :
      string[];
    
  moderators :
      string[];

constructor() 
{
      this.identifier = "" ;
        this.dateFrom = "" ;
        this.dateTo = "" ;
        this.title = "" ;
        this.openFrom = "" ;
        this.openTo = "" ;
        this.description = "" ;
        this.contatti = "" ;
        this.communities = [];
        this.admins = [];
        this.moderators = [];
  }
}

export

class CategoryItemsOfGuid {
    
  category :
      string;
    
  items :
      string[];

constructor() 
{
      this.category = "" ;
        this.items = [];
  }
}

export

class TagPostVM {
    
  communityIdentifier :
      string;
    
  tag :
      ForumTag;
    
  postsCount :
      number;
    
  lastPublishedPostDate :
      string;

constructor() 
{
      this.communityIdentifier = "" ;
        this.tag = new ForumTag();
        this.postsCount = null ;
        this.lastPublishedPostDate = "" ;
  }
}

export

class FriendRequestRoomVm extends BaseChatRoomVm {
    
  userIdentifier :
      string;
    
  fromUser :
      string;
    
  toUser :
      string;
    
  name :
      string;
    
  lastMessage :
      ChatRoomMessageVM;

constructor() 
{
  super();
      this.userIdentifier = "" ;
        this.fromUser = "" ;
        this.toUser = "" ;
        this.name = "" ;
        this.lastMessage = new ChatRoomMessageVM();
  }
}

export

class MakeFriendRequestVm {
    
  userIdentifier :
      string;
    
  firstMessageText :
      string;

constructor() 
{
      this.userIdentifier = "" ;
        this.firstMessageText = "" ;
  }
}

export

class LocalizedEntityVM {
    
  identifier :
      string;
    
  key :
      string;
    
  translations :
      { [key: string]: string; };

constructor() 
{
      this.identifier = "" ;
        this.key = "" ;
        this.translations = {};
  }
}

export

class LocalizedValue {
    
  values :
      LocalizedText[];

constructor() 
{
      this.values = [];
  }
}

export

class LocalizedEntity extends LocalizedValue {
    
  key :
      string;
    
  identifier :
      string;

constructor() 
{
  super();
      this.key = "" ;
        this.identifier = "" ;
  }
}

export

class LocalizedText {
    
  text :
      string;
    
  cultureName :
      string;
    
  isHtml :
      boolean;

constructor() 
{
      this.text = "" ;
        this.cultureName = "" ;
        this.isHtml = false ;
  }
}

export

class KeyValuePairOfStringAndString {
    
  key :
      string;
    
  value :
      string;

constructor() 
{
      this.key = "" ;
        this.value = "" ;
  }
}

export

class NexiClientModel {
    
  amount :
      string;
    
  transactionCode :
      string;
    
  currency :
      string;
    
  timeStamp :
      number;
    
  mac :
      string;
    
  url :
      string;
    
  urlBack :
      string;
    
  urlPost :
      string;
    
  apiKey :
      string;
    
  clientUrl :
      string;

constructor() 
{
      this.amount = "" ;
        this.transactionCode = "" ;
        this.currency = "" ;
        this.timeStamp = null ;
        this.mac = "" ;
        this.url = "" ;
        this.urlBack = "" ;
        this.urlPost = "" ;
        this.apiKey = "" ;
        this.clientUrl = "" ;
  }
}

export

class PaymentRequestVm {
    
  orderIdentifier :
      string;
    
  amount :
      number;
    
  paymentMethod :
      string;
    
  paymentMethodType :
      string;
    
  transactionId :
      string;

constructor() 
{
      this.orderIdentifier = "" ;
        this.amount = null ;
        this.paymentMethod = "" ;
        this.paymentMethodType = "" ;
        this.transactionId = "" ;
  }
}

export

class NexiPaymentRequest {
    
  orderIdentifier :
      string;
    
  xpayEsito :
      string;
    
  xpayIdOperazione :
      string;
    
  xpayNonce :
      string;
    
  xpayTimeStamp :
      string;
    
  xpayMac :
      string;
    
  codiceTransazione :
      string;
    
  importo :
      string;
    
  divisa :
      string;

constructor() 
{
      this.orderIdentifier = "" ;
        this.xpayEsito = "" ;
        this.xpayIdOperazione = "" ;
        this.xpayNonce = "" ;
        this.xpayTimeStamp = "" ;
        this.xpayMac = "" ;
        this.codiceTransazione = "" ;
        this.importo = "" ;
        this.divisa = "" ;
  }
}

export

class Notification extends BaseEntity {
    
  disabledOn :
      string;
    
  recipientIdentifier :
      string;
    
  title :
      string;
    
  text :
      string;
    
  data :
      NotificationDictionary;
    
  readOn :
      string;

constructor() 
{
  super();
      this.disabledOn = "" ;
        this.recipientIdentifier = "" ;
        this.title = "" ;
        this.text = "" ;
        this.data = new NotificationDictionary();
        this.readOn = "" ;
  }
}

export

class NotificationDictionary {
    
  route :
      string;
    
  userIdentifier :
      string;
    
  friendRequestIdentifier :
      string;
    
  itemIdentifier :
      string;
    
  parentIdentifier :
      string;
    
  grandParentIdentifier :
      string;
    
  containerIdentifier :
      string;
    
  notificationType :
      string;

constructor() 
{
      this.route = "" ;
        this.userIdentifier = "" ;
        this.friendRequestIdentifier = "" ;
        this.itemIdentifier = "" ;
        this.parentIdentifier = "" ;
        this.grandParentIdentifier = "" ;
        this.containerIdentifier = "" ;
        this.notificationType = "" ;
  }
}

export

class OrderResumeVM {
    
  orderIdentifier :
      string;
    
  orderNumber :
      string;
    
  userEmail :
      string;
    
  communityTitle :
      string;
    
  totalPrice :
      number;
    
  orderStatus :
      OrderStatus;
    
  eventOrCommunity :
      string;

constructor() 
{
      this.orderIdentifier = "" ;
        this.orderNumber = "" ;
        this.userEmail = "" ;
        this.communityTitle = "" ;
        this.totalPrice = null ;
        this.orderStatus = null;
        this.eventOrCommunity = "" ;
  }
}

export enum OrderStatus {
    Created = 0,
    Paid = 1,
    Closed = 2,
}

export

class BackofficeOrderModelVM {
    
  communityName :
      string;
    
  orders :
      OrderResumeVM[];

constructor() 
{
      this.communityName = "" ;
        this.orders = [];
  }
}

export

class OrderVM {
    
  orderNumber :
      string;
    
  userEmail :
      string;
    
  communityTitle :
      string;
    
  totalPrice :
      number;
    
  shipmentCosts :
      number;
    
  orderStatus :
      OrderStatus;
    
  notes :
      string;
    
  cartItems :
      CartItemVM[];
    
  shippingAddress :
      Address;

constructor() 
{
      this.orderNumber = "" ;
        this.userEmail = "" ;
        this.communityTitle = "" ;
        this.totalPrice = null ;
        this.shipmentCosts = null ;
        this.orderStatus = null;
        this.notes = "" ;
        this.cartItems = [];
        this.shippingAddress = new Address();
  }
}

export

class ChangeOrderStatusVM {
    
  identifier :
      string;
    
  status :
      OrderStatus;

constructor() 
{
      this.identifier = "" ;
        this.status = null;
  }
}

export

class ForumPostSearchVM {
    
  communityIdentifier :
      string;
    
  searchText :
      string;
    
  tags :
      ForumTag[];

constructor() 
{
      this.communityIdentifier = "" ;
        this.searchText = "" ;
        this.tags = [];
  }
}

export

class UpdatePostVm {
    
  identifier :
      string;
    
  title :
      string;
    
  text :
      string;
    
  publishedDate :
      string;
    
  removeAttachment :
      boolean;
    
  categoryAttachment :
      CategoryAttachmentVM;

constructor() 
{
      this.identifier = "" ;
        this.title = "" ;
        this.text = "" ;
        this.publishedDate = "" ;
        this.removeAttachment = false ;
        this.categoryAttachment = new CategoryAttachmentVM();
  }
}

export

class CreatePostVm {
    
  identifier :
      string;
    
  containerIdentifier :
      string;
    
  title :
      string;
    
  text :
      string;
    
  publishedDate :
      string;
    
  isAllegato :
      boolean;
    
  postType :
      string;
    
  categoryAttachment :
      CategoryAttachmentVM;

constructor() 
{
      this.identifier = "" ;
        this.containerIdentifier = "" ;
        this.title = "" ;
        this.text = "" ;
        this.publishedDate = "" ;
        this.isAllegato = false ;
        this.postType = "" ;
        this.categoryAttachment = new CategoryAttachmentVM();
  }
}

export

class CreateForumPostVm extends CreatePostVm {
    
  tag :
      ForumTag;

constructor() 
{
  super();
      this.tag = new ForumTag();
  }
}

export

class CreateReport {
    
  itemIdentifier :
      string;
    
  reportType :
      string;
    
  note :
      string;

constructor() 
{
      this.itemIdentifier = "" ;
        this.reportType = "" ;
        this.note = "" ;
  }
}

export

class ReportList {
    
  identifier :
      string;
    
  itemIdentifier :
      string;
    
  reportType :
      string;
    
  note :
      string;
    
  approvedOn :
      string;
    
  refusedOn :
      string;
    
  createdOn :
      string;
    
  submittedBy :
      TextIdentifier;

constructor() 
{
      this.identifier = "" ;
        this.itemIdentifier = "" ;
        this.reportType = "" ;
        this.note = "" ;
        this.approvedOn = "" ;
        this.refusedOn = "" ;
        this.createdOn = "" ;
        this.submittedBy = new TextIdentifier();
  }
}

export

class TextIdentifier {
    
  text :
      string;
    
  identifier :
      string;

constructor() 
{
      this.text = "" ;
        this.identifier = "" ;
  }
}

export

class CommunityShopItemsVM {
    
  communityName :
      string;
    
  items :
      BaseShopItemVM[];

constructor() 
{
      this.communityName = "" ;
        this.items = [];
  }
}

export

class BaseShopItemVM {
    
  identifier :
      string;
    
  category :
      string;
    
  title :
      string;
    
  thumbnailUrl :
      string;
    
  price :
      number;
    
  slug :
      string;

constructor() 
{
      this.identifier = "" ;
        this.category = "" ;
        this.title = "" ;
        this.thumbnailUrl = "" ;
        this.price = null ;
        this.slug = "" ;
  }
}

export

class CategoryShopItemVM {
    
  title :
      string;
    
  category :
      string;
    
  description :
      string;
    
  isShipable :
      boolean;
    
  gallery :
      string[];
    
  thumbnailUrl :
      string;
    
  shopItemVariations :
      ShopItemVariationAvailability[];
    
  slug :
      string;
    
  identifier :
      string;

constructor() 
{
      this.title = "" ;
        this.category = "" ;
        this.description = "" ;
        this.isShipable = false ;
        this.gallery = [];
        this.thumbnailUrl = "" ;
        this.shopItemVariations = [];
        this.slug = "" ;
        this.identifier = "" ;
  }
}

export

class ShopItemVariationAvailability {
    
  identifier :
      string;
    
  availability :
      number;
    
  variation :
      ShopItemVariation;

constructor() 
{
      this.identifier = "" ;
        this.availability = null ;
        this.variation = new ShopItemVariation();
  }
}

export

class BaseShopItem extends BaseEntity {
    
  disabledOn :
      string;
    
  ownerIdentifier :
      string;
    
  title :
      string;
    
  thumbnail :
      Attachment;
    
  category :
      string;
    
  isShipable :
      boolean;
    
  slug :
      string;

constructor() 
{
  super();
      this.disabledOn = "" ;
        this.ownerIdentifier = "" ;
        this.title = "" ;
        this.thumbnail = new Attachment();
        this.category = "" ;
        this.isShipable = false ;
        this.slug = "" ;
  }
}

export

class ShopItem extends BaseShopItem {
    
  description :
      string;
    
  shopItemVariations :
      ShopItemVariationAvailability[];
    
  gallery :
      Attachment[];

constructor() 
{
  super();
      this.description = "" ;
        this.shopItemVariations = [];
        this.gallery = [];
  }
}

export

class EditItemVm {
    
  identifier :
      string;
    
  category :
      string;
    
  title :
      string;
    
  description :
      string;
    
  isShipable :
      boolean;
    
  communityIdentifier :
      string;

constructor() 
{
      this.identifier = "" ;
        this.category = "" ;
        this.title = "" ;
        this.description = "" ;
        this.isShipable = false ;
        this.communityIdentifier = "" ;
  }
}

export

class CreateItemVariationVm {
    
  variations :
      { [key: string]: string; };
    
  availability :
      number;
    
  price :
      number;
    
  itemIdentifier :
      string;
    
  index :
      number;

constructor() 
{
      this.variations = {};
        this.availability = null ;
        this.price = null ;
        this.itemIdentifier = "" ;
        this.index = null ;
  }
}

export

class CreateDateItemVariationVm extends CreateItemVariationVm {
    
  date :
      string;

constructor() 
{
  super();
      this.date = "" ;
  }
}

export

class CreatePeriodItemVariationVm extends CreateItemVariationVm {
    
  period :
      DatePeriod;

constructor() 
{
  super();
      this.period = new DatePeriod();
  }
}

export

class ShopAppVM {
    
  cartIdentifier :
      string;
    
  baseShopItemsVM :
      BaseShopItemVM[];
    
  pdfUrl :
      string;
    
  slug :
      string;

constructor() 
{
      this.cartIdentifier = "" ;
        this.baseShopItemsVM = [];
        this.pdfUrl = "" ;
        this.slug = "" ;
  }
}

export

class AppUserVm {
    
  identifier :
      string;
    
  firstSetupDone :
      boolean;
    
  completed :
      boolean;
    
  profileCompleted :
      boolean;
    
  name :
      string;
    
  email :
      string;
    
  telephone :
      string;
    
  categories :
      string[];
    
  role :
      string;

constructor() 
{
      this.identifier = "" ;
        this.firstSetupDone = false ;
        this.completed = false ;
        this.profileCompleted = false ;
        this.name = "" ;
        this.email = "" ;
        this.telephone = "" ;
        this.categories = [];
        this.role = "" ;
  }
}

export

class BackendUserVm {
    
  identifier :
      string;
    
  name :
      string;
    
  email :
      string;
    
  role :
      string;

constructor() 
{
      this.identifier = "" ;
        this.name = "" ;
        this.email = "" ;
        this.role = "" ;
  }
}

export

class SearchUserVM {
    
  identifier :
      string;
    
  completeName :
      string;
    
  username :
      string;

constructor() 
{
      this.identifier = "" ;
        this.completeName = "" ;
        this.username = "" ;
  }
}

export

class DateIdentifier {
    
  date :
      string;
    
  identifier :
      string;

constructor() 
{
      this.date = "" ;
        this.identifier = "" ;
  }
}

export

class UserProfileVm {
    
  identifier :
      string;
    
  name :
      string;
    
  surname :
      string;
    
  birthDate :
      string;
    
  places :
      Address[];
    
  gender :
      string;
    
  categories :
      string[];
    
  communityLiked :
      number;
    
  communityAdministrated :
      number;
    
  description :
      string;
    
  backgroundImage :
      string;

constructor() 
{
      this.identifier = "" ;
        this.name = "" ;
        this.surname = "" ;
        this.birthDate = "" ;
        this.places = [];
        this.gender = "" ;
        this.categories = [];
        this.communityLiked = null ;
        this.communityAdministrated = null ;
        this.description = "" ;
        this.backgroundImage = "" ;
  }
}

export

class UserSelfProfileVm extends UserProfileVm {
    
  email :
      string;
    
  telephone :
      string;

constructor() 
{
  super();
      this.email = "" ;
        this.telephone = "" ;
  }
}

export

class UserListVm {
    
  identifier :
      string;
    
  createdOn :
      string;
    
  confirmedOn :
      string;
    
  name :
      string;
    
  email :
      string;
    
  role :
      string;

constructor() 
{
      this.identifier = "" ;
        this.createdOn = "" ;
        this.confirmedOn = "" ;
        this.name = "" ;
        this.email = "" ;
        this.role = "" ;
  }
}

export

class SaveBackendUserVm {
    
  identifier :
      string;
    
  email :
      string;
    
  password :
      string;
    
  role :
      string;
    
  name :
      string;
    
  surname :
      string;
    
  birthDate :
      string;

constructor() 
{
      this.identifier = "" ;
        this.email = "" ;
        this.password = "" ;
        this.role = "" ;
        this.name = "" ;
        this.surname = "" ;
        this.birthDate = "" ;
  }
}

export

class CompleteProfileVM {
    
  email :
      string;
    
  name :
      string;
    
  surname :
      string;
    
  birthDate :
      string;

constructor() 
{
      this.email = "" ;
        this.name = "" ;
        this.surname = "" ;
        this.birthDate = "" ;
  }
}

export

class MandatoryDocumentCreateVM {
    
  categoryIdentifier :
      string;
    
  phraseToShow :
      LocalizedValue;
    
  documentName :
      LocalizedValue;
    
  urlDocument :
      string;
    
  type :
      string;

constructor() 
{
      this.categoryIdentifier = "" ;
        this.phraseToShow = new LocalizedValue();
        this.documentName = new LocalizedValue();
        this.urlDocument = "" ;
        this.type = "" ;
  }
}

export

class MandatoryDocumentAppVM {
    
  identifier :
      string;
    
  phraseToShow :
      string;
    
  documentName :
      string;
    
  urlDocument :
      string;

constructor() 
{
      this.identifier = "" ;
        this.phraseToShow = "" ;
        this.documentName = "" ;
        this.urlDocument = "" ;
  }
}

export

class MandatoryDocumentEditVM extends MandatoryDocumentCreateVM {
    
  identifier :
      string;

constructor() 
{
  super();
      this.identifier = "" ;
  }
}

export

class MandatoryDocumentListVM {
    
  identifier :
      string;
    
  category :
      TextIdentifier;
    
  phraseToShow :
      LocalizedValue;
    
  documentName :
      LocalizedValue;
    
  urlDocument :
      string;
    
  type :
      string;
    
  published :
      boolean;

constructor() 
{
      this.identifier = "" ;
        this.category = new TextIdentifier();
        this.phraseToShow = new LocalizedValue();
        this.documentName = new LocalizedValue();
        this.urlDocument = "" ;
        this.type = "" ;
        this.published = false ;
  }
}

export

class MandatoryDocumentCategoryCreateVM {
    
  category :
      string;

constructor() 
{
      this.category = "" ;
  }
}

export

class MandatoryDocumentCategoryEditVM extends MandatoryDocumentCategoryCreateVM {
    
  identifier :
      string;

constructor() 
{
  super();
      this.identifier = "" ;
  }
}

export

class MandatoryDocumentCategoryListVM {
    
  identifier :
      string;
    
  category :
      string;

constructor() 
{
      this.identifier = "" ;
        this.category = "" ;
  }
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}